import React, { FC } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useTranslation } from "react-i18next";

import Stepper from "./components/Stepper/Stepper";
import { StyledContentGrid, SidebarContainer } from "./MultistepForm.styled";
import FormSection from "./components/FormSection";
import Info from "./components/Info";
import TopNav from "./components/TopNav";
import FormWrapper from "./components/FormWrapper";
import { useMultistepFormStore } from "./MultistepForm.store";
import BackdropLoader from "../BackdropLoader";

import { Box, Grid } from "@components/base";

interface MultistepForm {}

const MultistepForm: FC<MultistepForm> = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const { activeInfo, validationSchema, isSubmissionPending } =
    useMultistepFormStore();
  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
  });

  return (
    <FormWrapper methods={methods}>
      <Grid container spacing={3} height="calc(100vh - 24px)">
        <Grid width={400} height="100%" pb={3}>
          <Stepper />
        </Grid>

        <StyledContentGrid
          size="grow"
          pb={3}
          height="100%"
          sx={{
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            minHeight: 0,
            minWidth: 0,
          }}
        >
          <TopNav setValue={methods.setValue} />

          <Box
            mt={3}
            mr={!activeInfo || isMobile ? 0 : "390px"}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
            }}
          >
            <FormSection />
          </Box>
        </StyledContentGrid>

        {activeInfo && (
          <SidebarContainer>
            <Info />
          </SidebarContainer>
        )}
      </Grid>

      <BackdropLoader
        isVisible={isSubmissionPending}
        label={t("form.submitting", "Submitting form...")}
      />
    </FormWrapper>
  );
};

export default MultistepForm;
